import { html } from 'fxjs/es';
import { reloadIcon } from '../../../Ness/Core/S/Tmpl/icon.js';
import { NESS_CUSTOM_USER_PRODUCT_LIST_URL } from '../../../Ness/S/Constant/custom.js';

export const loginMessage = () => {
  const origin_url = G.NESS_MAIN_LINK.replace(/(http|https):\/\//, '$1://maplestory.');
  return html`
    <div class="message-container no-login">
      <div class="message">${ET('labs::main::login_1')}</div>
      <div class="message">${ET('labs::main::login_2')}</div>
      <a class="login-button" href="${origin_url}/@/login?url=${NESS_CUSTOM_USER_PRODUCT_LIST_URL()}"
        >${ET('labs::main::login_3')}</a
      >
    </div>
  `;
};

export const noCharacterMessage = () =>
  html` <div class="message-container no-character">
    <div class="message">${ET('labs::main::no_chracter_1')}</div>
    <div class="message">${ET('labs::main::no_chracter_2')}</div>
  </div>`;

export const errorCharacterMessage = () =>
  html` <div class="message-container no-character">
    <div class="message">${ET('labs::main::no_chracter_1_1')}</div>
    <div class="message">${ET('labs::main::no_chracter_2')}</div>
    <div class="info-container notice">
      <div class="message">${ET('labs::error::notice')}</div>
      <button class="reload_character">${ET('labs::error::reload')}</button>
    </div>
  </div>`;

export const reloadContainer = () => {
  return html`
    <div class="labs__main-container__reload-container">
      <button class="reload-button">${ET('labs::error::reload')}${reloadIcon()}</button>
      <div class="labs__main-container__reload-container__desc">캐릭터가 보이지 않나요?</div>
    </div>
  `;
};
